import {SPECTATOR_COLOR, SPECTATOR_ID} from "../../constants/players";

// Один замороженный объект на всех: getActingPlayer отдает его зрителю на
// каждом рендере, и новый объект на каждый вызов перезапускал бы эффекты с
// actingPlayer в зависимостях (таймер хода в CompletePhaseButton — по кругу)
const SPECTATOR_MOCK = Object.freeze({
  id: SPECTATOR_ID,
  color: SPECTATOR_COLOR,
});

export const getSpectatorMock = () => {
  return SPECTATOR_MOCK;
}
